<template>
      <div class="signarrow">
        <div class="signup"><img @click="gosignup" src="../../assets/signup.png" /></div>
      </div>
  </template>
  <script>
    export default {
      methods:{
        gosignup() {
          var keys=Object.keys(this.$route.query);
          var temp=""
          for(var i=0;i<keys.length;i++) {
            temp=temp+keys[i]+'='+this.$route.query[keys[i]]+"&"
          }
          var params=temp.substring(0,temp.length-1)
          this.$router.push("/signup?"+params)
        }
      }
    }
  </script>
  <style scoped>
  
    .signarrow {
      position: absolute;
      width: 100%;
      bottom: 18vw;
    }
    .signup {
      text-align: center;
      /*margin-bottom: 33px;*/
    }
    .signup img {
      width: 77vw;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/common/singup.vue